import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { type ModalInstance } from './modal.types';

@Injectable({
  providedIn: 'root',
})
export class ModalCompareService {
  comparingMode: boolean;
  private modalSubject = new ReplaySubject<ModalInstance[]>(1);
  modals$ = this.modalSubject.asObservable();
  private comparingSubject = new ReplaySubject<boolean>(1);
  comparing$ = this.comparingSubject.asObservable();

  notifyModals(modals: ModalInstance[]) {
    this.modalSubject.next(modals);
  }

  notifyComparing(comparing: boolean) {
    // compare mode needs to be true to allow any compare to happen.
    this.comparingSubject.next(this.comparingMode && comparing);
  }

  setComparingMode(newComparingMode: boolean) {
    this.comparingMode = newComparingMode;
  }
}
